function BypassProvider() {
  return /* @__PURE__ */ new Set(["required", "analytics", "functional"]);
}
export {
  BypassProvider
};
//# sourceMappingURL=bypass-provider.js.map
